import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const loadingContainer = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1
});

export const contentContainer = style({
  backgroundColor: colors.hooplaBackgroundLightGray,
  paddingLeft: "calc(100vw - 100%)",
  flex: 1,
  width: "100%",
  justifyContent: "center",
  display: "flex"
});

export const content = style(
  {
    marginTop: "1rem",
    padding: "0 1rem",
    width: "100%"
  },
  media(queries.medium, {
    marginTop: "3rem",
    padding: 0,
    width: "48rem"
  }),
  media(queries.large, {
    width: "65rem"
  })
);

export const error = style({
  display: "flex",
  color: "red",
  justifyContent: "center",
  padding: "2rem"
});
